import { Component } from '@angular/core';

@Component({
  selector: 'blank',
  templateUrl: 'blankLayout.template.html',
  styleUrls: ['./blankLayout.component.scss']
})
export class BlankLayoutComponent {


  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  customerSelected(c){
    
  }
}
